import { Component, OnInit } from '@angular/core';

import { DevExtremeModule } from 'devextreme-angular';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService } from '../../../core/app-information.service';
import { AuthService } from '../../../core/auth.service';
import { ArkUnitOfWork } from '../../../core/core.module';

@Component({
    selector: 'app-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class PasswordComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    user: any;
    userInfo: any;

    constructor(
        public modalRef: BsModalRef,
        private uow: ArkUnitOfWork,
        private appInfo: AppInformationService,
        private auth: AuthService
    ) {}

    async ngOnInit() {
        this.user = this.auth.currentUser;
        console.log(this.user);
        this.userInfo = {};
        this.userInfo.currentUser = '';
        this.userInfo.currentPassword = '';
        this.userInfo.newPassword1 = '';
        this.userInfo.newPassword2 = '';
    }

    async save() {
        // await this.uow.commit();
        this.result.next({ result: true });
        this.modalRef.hide();
    }

    cancel() {
        // this.uow.rollback();
        this.modalRef.hide();
    }
}
